module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent menu-edit-wrapper"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.source.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter menu name",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(_vm.orderChanged) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                Items order changed. Don't forget to save it!\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-builder"
  }, [_c('div', {
    staticClass: "menu-builder__btns"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addItemToTop
    }
  }, [_vm._v("Add item")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "menu-builder-inner"
  }, [_c('ul', _vm._l((_vm.menuTree), function(item) {
    return _c('menu-item', {
      key: item.id,
      attrs: {
        "content": item
      }
    })
  }), 1)]), _vm._v(" "), (_vm.menuTree.length > 5) ? _c('div', {
    staticClass: "menu-builder__btns"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addItemToBottom
    }
  }, [_vm._v("Add item")])]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success save-menu",
    on: {
      "click": _vm.saveAll
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("Data saved successful!")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.saveErrorMessage))])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Builder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-builder-item-template",
    staticStyle: {
      "display": "none"
    }
  }, [_c('li', {
    staticClass: "menu-builder__item-wrap",
    attrs: {
      "data-id": ""
    }
  }, [_c('div', {
    staticClass: "menu-builder__item"
  }, [_c('div', {
    staticClass: "menu-builder__item-inner"
  }, [_c('div', {
    staticClass: "menu-builder__item-img"
  }, [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-data"
  }, [_c('div', {
    staticClass: "menu-builder__item-data-row _id"
  }, [_c('b', [_vm._v("ID:")]), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-data-row _title"
  }, [_c('b', [_vm._v("Title:")]), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-data-row _url"
  }, [_c('b', [_vm._v("Url:")]), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-btns"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-add"
  }, [_vm._v("Add item")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-edit"
  }, [_vm._v("Edit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-open"
  }, [_vm._v("Open")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-delete"
  }, [_vm._v("Delete")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18672842","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/menu/Edit.vue
// module id = 827
// module chunks = 0